module.exports = __webpack_public_path__ + "img/home-index-menu3.83da43ee.png";